<template>
  <main class="main h-100 w-100" style="background: #f4f7fc">
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-sm-10 col-md-7 col-lg-5 mx-auto d-table h-100">
          <div class="d-table-cell align-middle">
            <div class="card mt-5">
              <div class="card-body" id="login_form">
                <div class="text-center">
                  <logo />
                </div>
                <h3 class="text-center my-4 text-muted fw-medium">Sign In</h3>
                <alert v-if="has_error" type="danger">Invalid Email and/or Password</alert>
                <form @submit.prevent="submit">
                  <div class="mb-3">
                    <label>Email</label>
                    <input
                      class="form-control form-control-lg"
                      type="email"
                      name="email"
                      placeholder="Enter your email"
                      v-model="user.email"
                    />
                  </div>
                  <div class="mb-3">
                    <label>Password</label>
                    <password
                      placeholder="Password"
                      name="password"
                      v-model="user.password"
                    />
                    <small>
                      <router-link :to="{ name: 'forgot-password' }"
                        >Forgot password?</router-link
                      >
                    </small>
                  </div>
                  <div class="text-center mt-3">
                    <button class="btn btn-lg btn-primary">
                      Sign in <i class="fal ms-2 me-0 fa-sign-in"></i>
                    </button>
                  </div>
                </form>
                <div class="mt-4 text-center">
                  <router-link :to="{ name: 'register' }"
                    >Dont have an account? Create Account.</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  mounted() {
    if (this.$storage.has("token")) {
      this.$router.push({ name: "main" });
    }
  },

  data() {
    return {
      user: {},
      has_error: false,
    };
  },

  methods: {
    submit() {
      this.has_error = false;

      let data = {
        form_id: "login_form",
        email: this.user.email,
        password: this.user.password,
      };

      this.$axios
        .post("/api/v1/login", data)
        .then((response) => {
          this.$storage.set("token", response.data.access_token);
          window.location.href = this.$router.resolve({ name: "main" }).href;
        })
        .catch(() => {
          this.has_error = true;
        });
    },
  },
};
</script>
